import styles from "./Features.module.scss";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation("translation");

  const features = [
    {
      icon: "🚚",
      title: t("free_delivery") || "Pulsuz çatdırma",
    },
    {
      icon: "💳",
      title: t("secure_payment") || "Etibarlı ödəniş təsisatı",
    },
    {
      icon: "📧",
      title: t("post_delivery") || "Poçtə çatdırma",
    },
    {
      icon: "↩️",
      title: t("return_policy") || "14 gün ərzində pulsuz əvəz",
    },
  ];

  return (
    <section className={styles.features_section}>
      <div className="container">
        <div className={styles.features_grid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.feature_card}>
              <div className={styles.icon}>{feature.icon}</div>
              <div className={styles.content}>
                <h3 className={styles.title}>{feature.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
